<template>
  <div>
    <div class="notify" :class="isOpenNotify ? 'show' : ''" v-if="isOpenNotify" ref="notifyAppointment">
      <div class="d-flex align-items-center justify-content-between p-3">
        <span class="fw-700" style="font-size: 18px;">Thông báo</span>
        <div class="d-flex">
          <el-tooltip effect="dark" content="Đánh dấu tất cả đã đọc" placement="top-start" style="cursor: pointer;">
            <span class="material-icons me-1" style="font-size: 20px;" @click="readAll">done_all</span>
          </el-tooltip>
          <div class="d-flex align-items-center gap-1" style="cursor: pointer; margin-left: 10px;">
            <IconFont name="icon-navigation-setting" />
            <!-- <span>Cài đặt</span> -->
          </div>
        </div>

      </div>
      <div class="text-center" style="padding: 10px 15px 15px 15px" v-if="app.notificationAppointments.length == 0">
        Không có thông báo
      </div>
      <div v-for="(group, index) in app.notificationAppointments" :key="index">
        <div class="notify-item" style="border-top: 1px solid #EAECF2;">
          <div class="flex justify-between items-center">
            <div class="d-flex justify-content-between align-items-center" @click="toggleExpand(index)">
              <div class="d-flex align-items-center">
                <img class="nav-logo-img" style="height: 42px; width: 42px;" src="@/assets/logo.png" />
                <div style="font-size: 14px"
                  :class="{ 'unread': group.listNotification.some(noti => noti.status === 'UNREAD') }">
                  {{ getTitleNotiGroup(group) }}
                </div>
              </div>
              <div>
                <IconFont :class="['mt-1', expandedGroups[index] ? 'icon-arrow2-up' : 'icon-arrow2-down']">
                </IconFont>
              </div>
            </div>
          </div>

          <div class="mt-1">
            <div v-for="noti in (expandedGroups[index] ? group.listNotification : [group.listNotification[0]])"
              :key="noti.id" class="mb-2" :class="[{ 'group-noti': noti.status === 'UNREAD' }]"
              style="border: 1px solid #e4e7ed; padding: 6px; border-radius: 4px;" @click="readNotification(noti)">
              <div class="d-flex justify-content-between align-items-start gap-2">
                <div class="noti-body flex-grow-1">
                  <div :class="['noti-text', { 'unread': noti.status === 'UNREAD' }]">
                    <template v-if="isTaskNoti(noti)">
                      {{ taskNotiHeadline(noti) }}
                    </template>
                    <template v-else>
                      Lịch hẹn {{ noti.name }} với {{ noti.contactName }} - ({{ noti.phone }})
                    </template>
                  </div>
                  <div
                    class="noti-details"
                    :class="{ 'unread': noti.status === 'UNREAD' }"
                  >
                    {{ dateTimeFormat(noti.updateAt, "HH:mm DD/MM/YYYY") }} • {{ getMessageNoti(noti) }}
                  </div>
                </div>
                <div v-if="noti.status === 'UNREAD'" class="notification-dot flex-shrink-0"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <el-button v-if="loadMore && app.notificationAppointments.length > 0" type="info" plain style="width: 95%; align-items: center; margin: 0 10px 10px 10px"
        @click="loadMoreNoti">Xem thông báo trước</el-button>
    </div>
  </div>
</template>


<style scoped>
@import "../../assets/css/navbar.css";
@import "../../scss/index.scss";
</style>

<script>
/* eslint-disable */
import ContactDetail from "../contact/ContactDetail.vue";
import IconFont from "../common/IconFont.vue";
import { HTTP } from "@/lib/http-common";
import workflow from "@/lib/apis/workflow";
import CreateOrder from "../contact/CreateOrder.vue";

// Every BE notification type that relates to a task. Clicking any of
// these routes the user to /task and opens the detail dialog for
// noti.taskId — so they all need to be recognised here.
const TASK_NOTI_TYPES = new Set([
  'TASK_ASSIGN',
  'TASK_UPDATE_FIELD',
  'TASK_REMIND',
  'TASK_AUTOMATION',
  'TASK_LABEL',
  'TASK_COMMENT',
  // Legacy short aliases for older BE payloads.
  'UPDATE_FIELD',
]);
export default {
  name: "Navbar",
  props: ["isOpenNotify"],
  components: { IconFont, CreateOrder, ContactDetail },
  data() {
    return {
      listNotification: [
        {
          id: 1,
          title: "aaaa",
          content: "aaaaaa",
          date: 123847392,
          link: "aaaaa"
        }
      ],
      listUnreadNotification: [],
      contactNoti: {},
      showNoticontact: false,
      steps: [],
      selectedProcessId: [],
      processList: [],
      dialogOrder: false,
      loadMore: true,
      expandedGroups: {}
    };
  },
  computed: {
    shouldShowSelect() {
      const currentPath = this.$route.path;
      return currentPath === "/contact" || currentPath === "/report";
    },
    countUnread() {
      return this.app.countNotification;
    },
  },
  methods: {
    handleCloseRecordDetail() {
      // if (this.recordDetail1) {
      //   this.recordDetail = false;
      //   this.recordDetail1 = false;
      //   this.getAll();
      // } else {
      //   this.recordDetail = false;
      //   this.recordDetail1 = false;
      // }
    },
    handleUpdated(isUpdated) {
      // this.recordDetail1 = isUpdated;
    },
    closeRecordDetail(updatedStatus) {
      this.showNoticontact = false;
      // if (updatedStatus) {
      //   this.recordDetail = false;
      //   // this.getAll();
      //   // this.selectedContact = {};
      // } else {
      //   this.recordDetail = false;
      //   // this.selectedContact = {};
      // }
    },
    async getLastNoteContacts(contacts) {
      const contactIds = contacts.map(c => c.id);
      let body = {
        contactIds: contactIds
      }
      const res = await HTTP.post("/api/activity/get-last-note-contacts", body);
      this.noteData = res.data;
    },
    // Helper: a notification group is a Task one when its first item type is
    // any of the 3 task subtypes.
    isTaskGroup(group) {
      const t = group && group.listNotification && group.listNotification[0]
        && group.listNotification[0].type;
      return TASK_NOTI_TYPES.has(t);
    },
    isTaskNoti(noti) {
      return noti && TASK_NOTI_TYPES.has(noti.type);
    },
    async readAll() {
      // Mark every visible group's items as READ via the right endpoint.
      const hasTask = this.app.notificationAppointments.some((g) => this.isTaskGroup(g));
      const hasAppt = this.app.notificationAppointments.some((g) => !this.isTaskGroup(g));
      const calls = [];
      if (hasAppt) calls.push(HTTP.post('/api/notification/read-all-appointment'));
      if (hasTask) calls.push(HTTP.post('/api/notification/read-all-task'));
      await Promise.all(calls);
      this.app.notificationAppointments.forEach((group) => {
        group.listNotification.forEach((noti) => { noti.status = 'READ'; });
      });
    },
    async readNotification(noti) {
      const url = this.isTaskNoti(noti)
        ? '/api/notification/update-status-task'
        : '/api/notification/update-status-appointment';
      const res = await HTTP.post(url, [noti.id]);
      if (res.status === 'success') {
        noti.status = 'READ';
        if (this.isTaskNoti(noti)) {
          // Task notification → open detail dialog for the related task.
          // Route to /task first if needed, then ask TaskPage to open by id.
          const taskId = noti.taskId || noti.objectId || null;
          if (this.$route.path !== '/task') {
            await this.$router.push('/task').catch(() => {});
            setTimeout(() => this.$bus.$emit('openTaskDetail', taskId), 200);
          } else {
            this.$bus.$emit('openTaskDetail', taskId);
          }
          this.$emit('closeNotiAppointment');
          return;
        }
        if (this.$route.path !== '/contact') {
          this.$router.push('/contact');
          setTimeout(() => this.$bus.$emit('readNotiAppointment'), 1000);
        } else {
          this.$bus.$emit('readNotiAppointment');
        }
      } else {
        this.$alert('error', (res && res.error && res.error.message) || 'Lỗi');
      }
    },
    getTitleNotiGroup(group) {
      const length = group.listNotification.length;
      switch (group.type) {
        case "CREATE":
          return "Bạn có " + length + " khách hàng được thêm mới.";
        case "UPDATE_PARTICIPANTS":
          return "Bạn có " + length + " lịch hẹn thay đổi người tham gia.";
        case "UPDATE_STATUS":
          return "Bạn có " + length + " lịch hẹn được thay đổi trạng thái.";
        case "UPDATE_COLUMN":
          return "Bạn có " + length + " lịch hẹn được thay đổi thông tin.";
        case "TASK_ASSIGN":
          return "Bạn có " + length + " công việc mới được giao.";
        case "TASK_REMIND":
          return "Bạn có " + length + " nhắc việc.";
        case "TASK_AUTOMATION":
          return "Bạn có " + length + " hành động tự động hoá trên công việc.";
        case "TASK_UPDATE_FIELD":
        case "UPDATE_FIELD":
          return "Bạn có " + length + " công việc được cập nhật.";
        case "TASK_LABEL":
          return "Bạn có " + length + " thay đổi gắn / gỡ nhãn công việc.";
        case "TASK_COMMENT":
          return "Bạn có " + length + " bình luận mới trên công việc.";
        default:
          break;
      }
      return group.listNotification.length;
    },
    toggleExpand(index) {
      this.$set(this.expandedGroups, index, !this.expandedGroups[index]);
    },
    handleProcessChange() {
      let key = `${this.app.user.id}_${this.app.user.swUsername}`;
      this.setProcessLocalStorage(key, this.app.globalProcessId);
      this.$bus.$emit("changeProcessId");
    },
    async loadMoreNoti() {
      if (this.app.notificationAppointments.length > 0) {
        const lastNotification = this.app.notificationAppointments[this.app.notificationAppointments.length - 1];

        if (lastNotification && lastNotification.updateAt) {
          const lastNotificationDate = new Date(lastNotification.updateAt);

          if (isNaN(lastNotificationDate.getTime())) {
            console.error('Invalid updatedAt value:', lastNotification.updatedAt);
            return;
          }

          const previousDay = new Date(lastNotificationDate);
          previousDay.setDate(lastNotificationDate.getDate() - 1);

          const time = previousDay.toISOString().slice(0, 10);

          const [appts, tasks] = await Promise.all([
            this.fetchNotificationAppointment(time, 3),
            this.fetchNotificationTask(time, 3),
          ]);
          const next = this.mergeGroups(appts, tasks);
          this.app.notificationAppointments = [...this.app.notificationAppointments, ...next];
          this.loadMore = next.length > 0;
        } else {
          console.error('Invalid updatedAt:', lastNotification.updatedAt);
        }
      } else {
        console.error('No notifications available.');
      }
    },
    handleClickOutside(event) {
      const notifyEl = this.$refs.notifyAppointment;
      const isInsideNotify = notifyEl && notifyEl.contains(event.target);

      const isContactDetailOpen = !!this.$refs.recordDetail;
      const isCreateOrderOpen = !!this.$refs.createOrder;

      if (!isInsideNotify && !isContactDetailOpen && !isCreateOrderOpen) {
        this.$emit("closeNotiAppointment");
      }
    },
    getMessageNoti(noti) {
      switch (noti.type) {
        case "CREATE":
          return "được tạo bởi " + noti.actorUsername;
        case "UPDATE_PARTICIPANTS":
          return this.getOldValue(noti) + " -> " + this.getNewValue(noti);
        case "UPDATE_STATUS":
          return "Trạng thái: " + this.getOldValue(noti) + " -> " + this.getNewValue(noti);
        case "UPDATE_COLUMN":
          return "cập nhật bởi " + noti.actorUsername;
        case "TASK_ASSIGN":
          return noti.actorUsername ? ("giao bởi " + noti.actorUsername) : "Hệ thống";
        case "TASK_REMIND":
          return "Đã đến giờ nhắc";
        case "TASK_AUTOMATION":
          return this.localizeMessage(noti.message) || "Tự động hoá";
        case "TASK_UPDATE_FIELD":
        case "UPDATE_FIELD":
          return noti.actorUsername ? ("cập nhật bởi " + noti.actorUsername) : "Cập nhật";
        case "TASK_LABEL":
          return noti.actorUsername ? ("nhãn cập nhật bởi " + noti.actorUsername) : "Cập nhật nhãn";
        case "TASK_COMMENT":
          return noti.actorUsername ? (noti.actorUsername + " đã bình luận") : "Bình luận mới";
        default:
          break;
      }
      return "";
    },
    // Post-process a BE-shipped message so time-unit tokens (MINUTE / HOUR /
    // DAY / MONTH), often concatenated onto the number ("30MINUTE"), render
    // as the Vietnamese equivalents.
    localizeMessage(msg) {
      if (!msg) return msg;
      return String(msg)
        .replace(/(\d+)\s*MINUTES?/gi, '$1 phút')
        .replace(/(\d+)\s*HOURS?/gi, '$1 giờ')
        .replace(/(\d+)\s*DAYS?/gi, '$1 ngày')
        .replace(/(\d+)\s*MONTHS?/gi, '$1 tháng');
    },
    taskNotiHeadline(noti) {
      // Backend's Notification.message already contains a sentence like
      // "Bạn được giao việc: CV-110 — Demo sản phẩm". Render as-is when set,
      // otherwise fall back to a generic prefix per subtype.
      if (noti.message) return this.localizeMessage(noti.message);
      const code = noti.taskCode ? noti.taskCode : (noti.taskId ? 'CV-' + noti.taskId : 'công việc');
      if (noti.type === 'TASK_ASSIGN')     return 'Bạn được giao việc: ' + code;
      if (noti.type === 'TASK_REMIND')     return 'Nhắc việc: ' + code;
      if (noti.type === 'TASK_AUTOMATION') return 'Tự động hoá trên: ' + code;
      if (noti.type === 'TASK_UPDATE_FIELD'
          || noti.type === 'UPDATE_FIELD') return 'Cập nhật ' + code;
      if (noti.type === 'TASK_LABEL')      return 'Cập nhật nhãn trên: ' + code;
      if (noti.type === 'TASK_COMMENT')    return 'Bình luận mới trên: ' + code;
      return code;
    },
    getOldValue(noti) {
      let detail = JSON.parse(noti.details);
      switch (noti.type) {
        case "UPDATE_STATUS": {
          let statusMesOld = '';
          switch (detail.oldValue) {
            case "NOT_START":
              statusMesOld = "Chưa bắt đầu";
              break;
            case "DONE":
              statusMesOld = "Hoàn thành";
              break;
            case "CANCEL":
              statusMesOld = "Hủy";
              break;
          }
          return statusMesOld;
        }
        case "UPDATE_PARTICIPANTS": {
          let oldValue = [];
          try {
            oldValue = JSON.parse(detail.oldValue);
          } catch (e) {
            return "";
          }
          return oldValue?.length > 0 ? oldValue : "";
        }
      }
    },
    getNewValue(noti) {
      let detail = JSON.parse(noti.details);
      switch (noti.type) {
        case "UPDATE_STATUS": {
          let statusMesNew = '';
          switch (detail.newValue) {
            case "NOT_START":
              statusMesNew = "Chưa bắt đầu";
              break;
            case "DONE":
              statusMesNew = "Hoàn thành";
              break;
            case "CANCEL":
              statusMesNew = "Hủy";
              break;
          }
          return statusMesNew;
        }
        case "UPDATE_PARTICIPANTS": {
          let newEm = [];
          try {
            newEm = JSON.parse(detail.newValue);
          } catch (e) {
            return "";
          }
          return newEm?.length > 0 ? newEm : "(bỏ trống)";
        }
      }
    },
    async getAllWorkflows() {
      const response = await workflow.getWorkflow();
      this.steps = response.data.sort((a, b) => a.index - b.index);
    },
    openDialogOrder() {
      this.dialogOrder = true;
    },
    mergeGroups(a, b) {
      // Both lists are pre-grouped by day; sort the merged result by the most
      // recent `updateAt` in each group so newer events surface to the top.
      const all = (a || []).concat(b || []);
      return all.sort((g1, g2) => (g2.updateAt || 0) - (g1.updateAt || 0));
    },
    async initData() {
      if (this.isOpenNotify) {
        const time = new Date().toISOString().slice(0, 10);
        // Pull both feeds in parallel and merge.
        const [appts, tasks] = await Promise.all([
          this.fetchNotificationAppointment(time, 3),
          this.fetchNotificationTask(time, 3),
        ]);
        this.app.notificationAppointments = this.mergeGroups(appts, tasks);
        this.app.countUnreadNotiAppointment = 0;
      }
    },
    redirectPage(link) {
      return link;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    // this.getAllWorkflows();
    this.initData();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.beta {
  background-color: royalblue;
  color: white;
  font-size: 10px;
  padding: 2px 3px;
  font-weight: bold;
  border-radius: 4px;
  margin-top: 0.25rem;
}

.select-process>>>input,
i {
  background-color: rgba(10, 88, 192, 0.1);
  color: #0a58c0;
  border: 1px solid rgba(10, 88, 192, 0.4);
}

.notify {
  position: absolute;
  width: 400px;
  max-height: 600px;
  overflow-y: auto;
  right: 10px;
  background: #fff;
  top: 50px;
  z-index: 1111;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  opacity: 0;
  transform: rotateX(-90deg);
  transform-origin: top center;
  transition: opacity 0.3s ease-out;
  animation: rotateMenu 0.3s ease-in forwards;
}

@keyframes rotateMenu {
  0% {
    transform: rotateX(-90deg);
  }

  70% {
    transform: rotateX(10deg);
  }

  100% {
    transform: rotateX(0deg);
  }
}

.notify.show {
  opacity: 1;
}

.notify-item {
  padding: 10px 15px 15px 15px;
  cursor: pointer;
  text-decoration: none;
}

/* .notify-item:hover {
  background: #ced2d6;
  color: #0a58c0;
  font-weight: 600;
} */
.count-notify {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 12px;
  background: #e1002d;
  font-size: 10px;
  padding: 0 8px;
  color: #fff;
  z-index: 9;
}

.btn-conversation {
  height: 30px;
  width: 30px;
}

.img-logo {
  height: 30px;
  width: 30px;
  object-fit: contain;
}

.noti-body {
  /* Constrain so long task titles wrap inside the row instead of pushing
     the unread dot off-screen. min-width:0 lets the flex child shrink. */
  min-width: 0;
}
.noti-text {
  color: #2970DD;
  font-weight: 400;
  word-break: break-word;
  overflow-wrap: anywhere;
  /* Clamp the headline at 3 lines so unreasonably long task titles don't
     dominate the popover — full text is still readable in the detail
     dialog the click opens. */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.unread {
  font-weight: bold !important;
}

.noti-details {
  font-size: 12px;
  color: #9497A5;
  font-weight: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.notification-dot {
  width: 8px;
  height: 8px;
  background-color: #409EFF;
  border-radius: 50%;
  display: inline-block;
  margin-left: 8px;
}

.group-noti {
  background-color: #FAFAFA;
}
</style>
